export const StripePaymentModal: string = 'StripePaymentModal';
